<template>
  <div>
    <service-quest-list
      :category="2"
      :param="{ status: 2 }"
    ></service-quest-list>
  </div>
</template>

<script>
import ServiceQuestList from './list'

export default {
  components: { ServiceQuestList },
}
</script>